import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalSidebarAggQuery, {
	type GoalSidebarAggQuery as GoalSidebarAggQueryType,
} from '../components/GoalSidebar/agg/__generated__/GoalSidebarAggQuery.graphql';

export const goalSidebarAggResource = createRelayResource<GoalSidebarAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';
		const isCombinedAggQueryEnabled = fg('townsquare_enable_combined_agg_query_sidebar');

		// Escape `key` so JQL parses values containing `"` or `\`. Any SSR prefetch
		// for this resource must mirror this exactly. VOLTPLAT-344.
		const safeKey = key.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

		return {
			query: GoalSidebarAggQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				searchQuery: `key = "${safeKey}" AND (archived = false OR archived = true)`,
				containerId,
				isCombinedAggQueryEnabled,
			},
		};
	},
});
